import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import Dropzone from 'react-dropzone';

interface DropZoneUIProp {
  onDrop: (acceptedFiles: File[]) => void;
  desc: string;
  dataTestId?: string;
  inputDataTestId?: string;
}

export const DropZoneUI: FC<DropZoneUIProp> = (props: DropZoneUIProp) => {
  const { desc, onDrop, dataTestId, inputDataTestId } = props;

  return (
    <Dropzone onDrop={onDrop}>
      {({ getRootProps, getInputProps }) => (
        <section>
          <Box className="drop-zone" {...getRootProps()} data-testid={dataTestId}>
            <input {...getInputProps()} data-testid={inputDataTestId} />
            <Typography variant="body1">{desc}</Typography>
          </Box>
        </section>
      )}
    </Dropzone>
  );
};
